var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "export-config": _vm.exportConfig,
          cellClick: _vm.chooseRow,
          cellDbClick: _vm.updateRow,
        },
        on: { "toolbar-addData": _vm.addRow, "toolbar-delData": _vm.delRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "top_btns_box",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _c("div", { staticClass: "status_box" }, [
                        _c(
                          "span",
                          {
                            staticClass: "status_item active",
                            on: {
                              click: function ($event) {
                                return _vm.showRecord(1)
                              },
                            },
                          },
                          [_vm._v("分配记录")]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "btns_box" },
                        [
                          !_vm.navSwitch
                            ? _c(
                                "vxe-button",
                                { on: { click: _vm.showAssignPopFunc } },
                                [_vm._v(" 分配 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "formModal",
        {
          attrs: {
            title: "待分配的非企微客户",
            centered: "",
            footer: null,
            maskClosable: false,
            width: 1200,
            closable: true,
            visible: _vm.editModalVisible,
          },
          on: { cancelled: _vm.closeDetailPop },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { userId: _vm.editRowId },
                on: {
                  closeParent: _vm.closeDetailPop,
                  openParent: _vm.openDetailPop,
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择分配人",
            centered: "",
            closable: true,
            footer: null,
            maskClosable: true,
            width: 1200,
          },
          model: {
            value: _vm.showAssignPop,
            callback: function ($$v) {
              _vm.showAssignPop = $$v
            },
            expression: "showAssignPop",
          },
        },
        [
          _vm.showAssignPop
            ? _c("sonDeptUsersList", {
                ref: "sonDeptUsersList",
                attrs: { assignIdArr: _vm.assignIdArr, type: 1 },
                on: { closeParent: _vm.closePop, close: _vm.closePop },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "分配记录",
            centered: "",
            closable: true,
            footer: null,
            maskClosable: true,
            width: 1200,
          },
          model: {
            value: _vm.showAssignRecordPop,
            callback: function ($$v) {
              _vm.showAssignRecordPop = $$v
            },
            expression: "showAssignRecordPop",
          },
        },
        [_vm.showAssignRecordPop ? _c("inheritRecord") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }